module.exports = __webpack_public_path__ + "img/bec.351aaaf6.jpeg";